var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TradingPlatformTemplate from './TradingPlatformTemplates/TradingPlatformTemplate.html';
import { Connection } from '@shared/commons/Connection';
import { ConnectionStates } from '@shared/utils/Connections/connection.types';
import { DataCache } from '@shared/commons/DataCache';
import { TradingPlatformApp } from './Core/TradingPlatformApp';
import { LocalStorage } from '@shared/commons/LocalStorage';
import { UserWebStorage, UserWebStorageInstance } from '../user-web-storage';
import { Resources } from '@shared/localizations/Resources';
import { messageBoxHandler } from '@shared/utils/AppHandlers';
import { TerceraReconnectScreen } from '@front/controls/screen/TerceraReconnectScreen';
import { MainWindowBase } from '@front/controls/screen/MainWindowBase';
import { AppNames } from '@front/controls/UtilsClasses/FactoryConstants';
export class TradingPlatform extends MainWindowBase {
    constructor() {
        super(...arguments);
        this.selectedArrayHeaderButton = null;
        this.onConnectionsStateChanged = () => {
            const state = Connection.getState();
            switch (state) {
                case ConnectionStates.CONNECTED: {
                    const vendor = Connection.vendor;
                    const connName = LocalStorage.getLastConnectionName();
                    UserWebStorageInstance.reinit(vendor.GetLogin(), connName);
                    void this.loadingStarted();
                    break;
                }
                case ConnectionStates.DISCONNECTED:
                    DataCache.cleanup();
                    UserWebStorage.RestApiNotWork = false;
                    Resources.setNeedForceUpdateLocale();
                    // //this.stopPingLoop();
                    UserWebStorageInstance.clear();
                    break;
                case ConnectionStates.CONNECTION_LOST:
                    DataCache.cleanup();
                    TerceraReconnectScreen.startReconnection();
                    UserWebStorage.RestApiNotWork = false;
                    Resources.setNeedForceUpdateLocale();
                    // //this.stopPingLoop();
                    break;
            }
        };
        this.errorMultiPolicy = (disconectArguments) => {
            const disconnectReasonText = disconectArguments === null || disconectArguments === void 0 ? void 0 : disconectArguments.Text;
            if (disconnectReasonText != null) {
                alert(disconnectReasonText);
            }
        };
        this.loadingStarted = () => __awaiter(this, void 0, void 0, function* () {
            this._logoutReason = null;
            const brandingKey = Connection.vendor.loginParams.brandingKey; //  #86122 #85820 #86776 #87660 #87238
            if (brandingKey) {
                yield DataCache.GetBrandingRules(brandingKey);
            }
            // await DataCache.StartLoadingWaiting();
            // await SessionSettings.load();
            // this.startPingLoop();
        });
    }
    getClientPanel() {
        return this.el;
    }
    getType() {
        return AppNames.TradingPlatform;
    }
    oninit() {
        this.on('loginEvent', this.loginEvent);
    }
    oncomplete() {
        const msgBoxHanl = messageBoxHandler;
        msgBoxHanl.Show = undefined;
        msgBoxHanl.msgType = undefined;
        Connection.subscribeOnConnectStateChange(this.onConnectionsStateChanged);
        Connection.SubscribeOnErrorMultiPolicy(this.errorMultiPolicy);
    }
    loginEvent() {
        void this.set({
            login: false,
            onDisconnectHandler: () => {
                this.logoutEvt();
            }
        });
        this.StartPingLoop();
        void TradingPlatformApp.Init();
    }
    logoutEvt() {
        void this.set('login', true);
        this.StopPingLoop();
    }
    StartPingLoop() {
        const loop = function () {
            Connection.SendPing().then(function (value) { });
        };
        loop();
        this.pingInterval = setInterval(loop, 10000);
    }
    StopPingLoop() {
        clearInterval(this.pingInterval);
    }
    logoutEvent() {
        Connection.disconnect();
    }
    setBrandingWebHeader() { }
}
MainWindowBase.extendWith(TradingPlatform, {
    template: TradingPlatformTemplate,
    el: 'body',
    data: function () {
        return {
            login: true,
            loginLogoSource: 'assets/webdesktop/resources/LogoTradingPlatform.svg', // empty logo placeholder with "Powered by..." text
            onDisconnectHandler: null
        };
    },
    partials: {}
});
